import React, { forwardRef, useEffect, useState } from "react";
import {
    Button,
    Dialog,
    InputAdornment,
    Slide,
    TextField,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { actions as authActions } from "../Auth/_redux/authRedux";
import {
    RegisterWithMobile,
    VerifyRegister,
    loginWithMobile,
} from "../Homepage/pages/widgets/components/cruds";
import { useMediaQuery } from "react-responsive";
import ReactLoading from "react-loading";
import ReactCodeInput from "react-code-input";
import CounterProgress from "./CounterProgress";
import { Formik } from "formik";
import * as Yup from "yup";
import isValidIranianNationalCode from "../../../functions/nationalCodeValidation";
import "./Auth.css"

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default (props) => {
    const [codeValue, setCodeValue] = useState(null);
    const [phoneValue, setPhoneValue] = useState(null);
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [verifyTime, setVerifyTime] = useState(false);
    const [errMessage, setErrMessage] = useState(false);
    const [isPinLoading, setIsPinLoading] = useState(false);
    const [codeErrMessage, setCodeErrMessage] = useState(null);
    const [userInfo, setUserInfo] = useState({
        firstName: "", lastName: "", nationalCode: "", phone: "", email: "", password: "",
    });
    const [isNationalCode, setIsNationalCode] = useState(false);
    const [isNationalCodeError, setIsNationalCodeError] = useState(false);
    // const phoneValidation = /^09\d{9}$/;
    const propsz = {
        className: "class-Input ",
        inputStyle: {
            textAlign: "center",
            fontFamily: "sans",
            borderRadius: "6px",
            border: "1px solid lightgrey",
            boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
            margin: "4px",
            paddingLeft: "8px",
            paddingRight: "0px",
            width: "10%",
            height: "42px",
            fontSize: "32px",
            boxSizing: "border-box",
            color: "black",
            backgroundColor: "white",
            direction: "ltr",
            flexGrow: 1,
        },
        touch: {
            border: "1px solid green",
        },
        inputStyleInvalid: {
            fontFamily: "monospace",
            margin: "4px",
            MozAppearance: "textfield",
            width: "15px",
            borderRadius: "3px",
            fontSize: "14px",
            height: "26px",
            paddingLeft: "7px",
            backgroundColor: "red",
            color: "red",
            border: "1px solid red",
        },
    };

    // Yup.addMethod(Yup.string, "validNationalCode", function (errorMessage) {
    //     return isValidIranianNationalCode(this)
    // });

    const yupValidationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required("لطفا نام خود را وارد کنید")
            .typeError(""),
        lastName: Yup.string()
            .required("لطفا نام خانوادگی را وارد کنید")
            .typeError(""),
        nationalCode: Yup.string()
            .required("لطفا کدملی را وارد کنید"),
        // .min(10, "کارکترهای وارد شده کمتر از حد مجاز است")
        // .max(10, "کارکترهای وارد شده بیشتر از حد مجاز است"),
        // .validNationalCode("کد ملی وارد شده صحیح نیست"),
        // .typeError(""),
        phone: Yup.string()
            // .min(10, "کارکترهای وارد شده کمتر از حد مجاز است")
            // .max(10, "کارکترهای وارد شده بیشتر از حد مجاز است")
            .required("لطفا شماره موبایل خود را وارد کنید")
            .matches(
                /^09\d{9}$/,
                "شماره وارد شده اشتباه میباشد"
              )
            .typeError(""),
    });

    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

    const registerHandler = (values) => {
        var data;
        if (values != undefined || values != null) {
            data = {
                firstName: values.firstName,
                lastName: values.lastName,
                nationalCode: values.nationalCode,
                // phone: `${+values.phone[0] === 0 ? values.phone : `0${values.phone}`}`,
                phone: values.phone,
                email: values?.email,
                password: values?.password,
            };
        } else {
            data = {
                firstName: userInfo?.firstName,
                lastName: userInfo?.lastName,
                nationalCode: userInfo?.nationalCode,
                phone: `${+userInfo?.phone[0] === 0 ? userInfo?.phone : `0${userInfo?.phone}`}`,
                // phone: userInfo?.phone,
                email: userInfo?.email,
                password: userInfo?.password,
            };
        }
        setIsLoginLoading(true);
        RegisterWithMobile(data)
            .then((respons) => {
                if (respons.status === 200) {
                    setErrMessage(null);
                    setVerifyTime(true);
                    setIsLoginLoading(false);
                }

            })
            .catch((err) => {
                setIsLoginLoading(false);

                if (err.response.status === 422) {
                    setErrMessage(err.response.data.errors[0].msg);
                } else {
                    setErrMessage("مشکلی در ارتباط با سرور بوجود آمد");
                }
            });
    }

    const registerVerifier = (code = null) => {
        let codeValueTemp = codeValue
        if (code != null) {
            codeValueTemp = code;
        }
        const data = {
            phone: `${+userInfo?.phone[0] === 0 ? userInfo?.phone : `0${userInfo?.phone}`}`,
            // phone: userInfo?.phone,
            code: codeValueTemp,
        };

        setIsPinLoading(true);

        VerifyRegister(data)
            .then((res) => {
                setIsPinLoading(false);
                const date = new Date();
                date.setDate(date.getDate() + 1);
                const dateOBJ = { date };
                localStorage.setItem("tokenExpireTime", JSON.stringify(dateOBJ));
                dispatch(authActions.login(res.data.data));
                window.localStorage.setItem(
                    "userInformation",
                    JSON.stringify(res.data.data)
                );
                if (props.buyTicketHandler) {
                    props.buyTicketHandler(res);
                }
                props.handleClose();
            })
            .catch((err) => {
                setIsPinLoading(false);

                if (err.response.data.message === "code is not valid!") {
                    setCodeErrMessage("کد نامعتبر است");
                } else {
                    setCodeErrMessage("مشکلی در ارتباط با سرور بوجود آمد");
                }
            });
    };

    // درصورت ارسال مجدد کد این کد اجرا میشود.
    const resendVerifyCode = () => { 
        const data = {
            phone: `${+userInfo?.phone[0] === 0 ? userInfo?.phone : `0${userInfo?.phone}`}`,
            // phone: userInfo?.phone,
        };
        setIsLoginLoading(true);
        loginWithMobile(data)
            .then((e) => {
                setVerifyTime(true);
                setIsLoginLoading(false);
                setErrMessage(null);

            })
            .catch((err) => {
                setIsLoginLoading(false);
                if (err.response.data.status === 404) {
                    setErrMessage("کاربری با شماره تلفن وارد شده یافت نشد");
                } else {
                    setErrMessage("مشکلی در ارتباط با سرور بوجود آمد");
                }
            });
    };

    const componentChangeHandler = (type, value) => {

        switch (type) {
            case "code":
                return setCodeValue(value);
            case "mobile":
                return setPhoneValue(value);
        }
    };

    useEffect(() => {
        setUserInfo({ ...userInfo, phone: props.phone ? props.phone : null })
    }, [])

    return (
        <Formik
            enableReinitialize
            validateOnBlur={true}
            initialValues={userInfo}
            validationSchema={yupValidationSchema}
            onSubmit={(values) => {
                values.phone = `${+values.phone[0] === 0 ? values.phone : `0${values.phone}`}`
                setUserInfo(values);
                registerHandler(values);
            }}
        >
            {({ handleSubmit, errors, touched, isSubmitting, setFieldValue, values, }) => {
                return (
                    <div className="row">
                        <Dialog
                            className="col-12"
                            open={props.open}
                            TransitionComponent={Transition}
                            fullScreen={isMobile ? true : false}
                            keepMounted
                            onClose={props.handleClose}
                            // PaperProps={{
                            //     style: { minWidth: "55rem", minHeight: "35rem" },
                            // }}
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <div className="d-flex justify-content-start container pt-5">
                                <i
                                    className="fa fa-times"
                                    style={{ fontSize: "20px", color: "#6dd06d" }}
                                    onClick={() => {
                                        props.handleClose();
                                    }}
                                ></i>
                            </div>

                            {!verifyTime ? (
                                <>
                                    <div className="w-100 d-flex flex-column p-3 my-3 "
                                        style={{
                                            overflowX: "hidden"
                                        }}
                                    >
                                        <span className="mx-auto my-2" style={{ fontSize: "20px" }} >ثبت نام</span>
                                        <p className="mx-auto my-3">
                                            لطفا مشخصات خود را وارد کنید.
                                        </p>
                                        <div className="row pb-md-4">
                                            <div className="col-md-6 col-lg-6 w-100 px-8">
                                                <TextField
                                                    label="نام"
                                                    className="mx-auto my-2"
                                                    variant="outlined"
                                                    id="outlined-start-adornment"
                                                    placeholder="نام"
                                                    onChange={(e) => setFieldValue("firstName", e.target.value)}
                                                />
                                                {touched.firstName ? (
                                                    <div className="text-danger">
                                                        {errors.firstName}
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className="col-md-6 col-lg-6 px-8">
                                                <TextField
                                                    label="نام خانوادگی"
                                                    className="mx-auto my-2"
                                                    variant="outlined"
                                                    id="outlined-start-adornment"
                                                    placeholder="نام خانوادگی"
                                                    onChange={(e) => setFieldValue("lastName", e.target.value)}
                                                />
                                                {touched.lastName ? (
                                                    <div className="text-danger ">
                                                        {errors.lastName}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="row pb-md-4">
                                            <div className="col-md-6 col-lg-6 px-8">
                                                <TextField
                                                    label="کد ملی"
                                                    className="mx-auto my-2"
                                                    variant="outlined"
                                                    id="outlined-start-adornment"
                                                    placeholder="کدملی"
                                                    onChange={(e) => {
                                                        setFieldValue("nationalCode", e.target.value);
                                                        const isNationalCodeValid = isValidIranianNationalCode(
                                                            e.target.value
                                                        );
                                                        if (isNationalCodeValid) {
                                                            setIsNationalCode(true);
                                                            setIsNationalCodeError(false)
                                                        } else {
                                                            setIsNationalCode(false);
                                                            setIsNationalCodeError(true)
                                                        }
                                                    }}
                                                />
                                                {touched.nationalCode ? (
                                                    <div className="text-danger">
                                                        {errors.nationalCode}
                                                    </div>
                                                ) : null}
                                                {isNationalCodeError ? (
                                                    <div className="text-danger">
                                                        کدملی را به درستی وارد کنید
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="col-md-6 col-lg-6 px-8">
                                                <TextField
                                                    label="شماره موبایل"
                                                    className=" mx-auto my-2"
                                                    variant="outlined"
                                                    onKeyUp={(e) => {
                                                        if (e.which === 13) {
                                                            registerHandler();
                                                        }
                                                    }}
                                                    id="outlined-start-adornment"
                                                    placeholder="شماره موبایل"
                                                    defaultValue={userInfo.phone}
                                                    onChange={(e) => {
                                                        setFieldValue("phone", e.target.value);
                                                        componentChangeHandler("phone", e.target.value);
                                                    }}
                                                />
                                                {touched.phone ? (
                                                    <div className="text-danger">
                                                        {errors.phone}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="row pb-md-4">
                                            <div className="col-md-6 col-lg-6 w-100 px-8">
                                                <TextField
                                                    label="ایمیل"
                                                    className="mx-auto my-2"
                                                    variant="outlined"
                                                    id="outlined-start-adornment"
                                                    placeholder="ایمیل (اختیاری)"
                                                    type="email"
                                                    onChange={(e) => setFieldValue("email", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-6 w-100 px-8">
                                                <TextField
                                                    label="رمز عبور"
                                                    className="mx-auto my-2"
                                                    variant="outlined"
                                                    id="outlined-start-adornment"
                                                    placeholder="رمزعبور (اختیاری)"
                                                    onChange={(e) => setFieldValue("password", e.target.value)}
                                                    inputProps={{
                                                        type: "password",
                                                        autoComplete: 'new-password'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <span className="mx-auto w-75 d-flex" style={{ color: "red" }}>
                                            <i
                                                className={`fa fa-exclamation-circle col-red mi-10 ${errMessage ? "d-block" : "d-none"
                                                    }`}
                                            ></i>
                                            {errMessage}
                                        </span>
                                        <div className="d-flex my-3 mx-auto w-75 gap-10 justify-flex-end">
                                            <Button
                                                className="btn  mx-auto text-white border15 w-100"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    backgroundColor: "#6dd06d",
                                                    width: "34rem",
                                                    height: "4rem",
                                                    fontSize: "16px",
                                                }}
                                                disabled={isSubmitting}
                                                onClick={() => {
                                                    handleSubmit()
                                                }}
                                            >
                                                {isLoginLoading ? (
                                                    <ReactLoading
                                                        type={"spin"}
                                                        color={"white"}
                                                        height={"12%"}
                                                        width={"12%"}
                                                    />
                                                ) : (
                                                    "تایید و دریافت کد"
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div
                                    className="w-100 d-flex flex-column p-3 my-3 "
                                    style={{ gap: "20px" }}
                                >
                                    <h2 className="mx-auto my-2">کد را وارد کنید</h2>
                                    <p className="mx-auto w-75 " style={{ fontSize: "14px" }}>
                                        کد 6 رقمی به شماره {values.phone} ارسال شد.
                                    </p>
                                    <div
                                        className="mx-auto w-75"
                                        onKeyUp={(e) => {
                                            if (e.which === 13) {
                                                registerVerifier();
                                            }
                                        }}
                                    >
                                        <ReactCodeInput
                                            {...propsz}
                                            type="number"
                                            fields={6}
                                            onChange={async (e) => {
                                                await componentChangeHandler("code", e);

                                                if (e != null && e.length == 6) {

                                                    await registerVerifier(e)
                                                }
                                                // if (!filterCharsIsWhitelist) {
                                                //   registerVerifier()
                                                // }
                                            }}
                                        />

                                        <h5 className="mt-5 d-flex col-red">
                                            <i
                                                style={{ color: "red", marginInline: "10px" }}
                                                className={`fa fa-exclamation-circle ${codeErrMessage ? "d-block" : "d-none"
                                                    }`}
                                            ></i>
                                            {codeErrMessage}
                                        </h5>
                                    </div>
                                    <CounterProgress handler={resendVerifyCode} />

                                    <div
                                        className="d-flex my-3 mx-auto w-75"
                                        style={{ justifyContent: "flex-end", gap: "10px" }}
                                    >
                                        <Button
                                            className="btn  mx-auto text-white border15 w-100"
                                            style={{
                                                whiteSpace: "nowrap",
                                                backgroundColor: "#6dd06d",
                                                width: "34rem",
                                                height: "4rem",
                                            }}
                                            onClick={() => {
                                                registerVerifier();
                                            }}
                                        >
                                            {isPinLoading ? (
                                                <ReactLoading
                                                    type={"spin"}
                                                    color={"white"}
                                                    height={"12%"}
                                                    width={"12%"}
                                                />
                                            ) : (
                                                "تایید"
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </Dialog>
                    </div>
                )
            }}
        </Formik>
    );
};